import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import {
    addEventAttribute,
    audienceButtons,
    changeAttribute,
    getAttribute,
    getBestImage,
    getImageWithPrefix,
    getLocalDate,
    hasAttribute,
    imagePad,
    manageAttractionData,
    MetaTags,
    setAttribute,
    setRoomAttribute,
    setUniqueAttractionAttribute,
    setUniqueEventAttribute, smallArtistCard,
    smallEventCard,
    thumbnailPad,
    toastSuccess
} from "../../components/common/utilities";
import ContentEditable from "react-contenteditable";
import PropertyNavigation from "../../components/common/navigation.component";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import metaDataLinks from "../../components/common/metaDataLinks";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {Dialog, Transition} from "@headlessui/react";
import {XMarkIcon} from "@heroicons/react/24/outline";
import FindAttractions from "./findAttractions";
import FindVenues from "../venues/findVenues";
import NLPPrompt from "../nlp/nlpprompt";
import {ToastContainer} from "react-toastify";
import MediaCollection from "../media/mediaCollection";
import EditDescriptions from "../../components/common/editdescriptions";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ArtistSources() {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log(data);

    type SchemaAttraction = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const text = useRef("");
    const inFocus = useRef("");
    const [sources, setSources] = useState([]);
    const [events, setEvents] = useState([]);
    const [photos, setPhotos] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [open, setOpen] = useState(false);
    const [showAI, setShowAI] = useState(false);
    const [showMediaSelector, setShowMediaSelector] = useState(false);
    const [attractionName, setAttractionName] = useState("");
    const [remoteArtist, setRemoteArtist] = useState<SchemaAttraction>();

    useEffect(() => {
        getArtist();
        //getEvents("");
        //getPhotos();

    }, []);
    const now = new Date();

    const getArtist = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/performer/data/sources.do?`, {

            artist: params.id, ticket: localStorage.getItem('ticket'),bust: now.toUTCString()
        }, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {
            // handle success
            //console.log(response.data);
            setSources(response.data)
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }

    const getRemoteArtist = (remoteid,source) => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/performer/data/sources.do?`, {

            remoteid: remoteid, source: source, ticket: localStorage.getItem('ticket'),bust: now.toUTCString()
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }

                   }).then(function (response) {
            // handle success
            console.log(response.data);
            setRemoteArtist(response.data)
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }



    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if(button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Event updated');

        }
        else if(button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            if(value === 'true')
            {
                toastSuccess('Event set to public');
            }
            else {
                toastSuccess('Event set to private');
            }

        }
        else if(button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            //viewEvent(null,eventid);
        }
        else if(button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Attraction Type set to '+value);

        }

        else if(button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key,value,unique,eventid);

            toastSuccess('Attribute '+key+' set to '+value);

        }

        else if(button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueAttractionAttribute('pgg.audience.'+key,'pgg.audience.'+value,unique,remove,eventid);

            toastSuccess('Audience set '+key+' Remove: '+remove);

        }
        else if(button === 'setDescription')
        {
            console.log('setting description');
            let key = "description-html-en";
            let value = e.target.dataset.description;
            let unique = true;
            let remove = false;
            let eventid = params.id;

            setUniqueAttractionAttribute(key,value,unique,remove,eventid);

            toastSuccess('Description set '+key+' Remove: '+remove);

        }


    }



    const getEvents = nextOffset => {
        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: {
                instance: 'promogogo', ticket: localStorage.getItem('ticket'), //guid: params.id,
                limit: 12, offset: nextOffset, artist: params.id, light: true,
            }

        }).then(function (response) {
            // handle success
            //console.log("events", response);
            setEvents(response.data.collection);

        });
    }

    const showMedia = () => {
        setShowAI(false);
        setShowMediaSelector(true);
        setOpen(true);
    }

    const showAIprompt = () => {
        setShowAI(true);
        setShowMediaSelector(false);
        setOpen(true);
    }









    return (

        <div className="min-h-full">

            <div className="mt-2">

                <main>

                    <div className="">
                        <div className="">
                            <div className="">
                                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">

                                    <div className="px-4 py-5 sm:p-6">
                                        <div className=" px-4 sm:mt-16 sm:px-0 lg:mt-0 md:grid md:grid-cols-2">
                                            <div className={'md:col-span-1'}>
                                                {remoteArtist && (<div
                                                    key={remoteArtist['@id']}
                                                    className="mt-2 relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"


                                                >
                                                    {remoteArtist.bestImage && <div className="md:flex-shrink-0">
                                                        {remoteArtist.bestImage && thumbnailPad(remoteArtist.bestImage)}
                                                        {!remoteArtist.bestImage && (<div
                                                            className="h-10 w-16 flex-shrink-0 rounded-full bg-gray-300"/>)}
                                                    </div>}
                                                    <div className="min-w-0 flex-1 pt-2 pb-2 p-1">
                                                        <div className="focus:outline-none">
                                                            <span className="absolute inset-0" aria-hidden="true"/>
                                                            <div
                                                                className="text-xs font-medium text-gray-900">{remoteArtist.name}</div>
                                                            {remoteArtist.bio && <>
                                                                <div className="text-xs text-gray-500">{remoteArtist.bio}</div>
                                                            </>}

                                                            <div className={'grid md:grid-cols-3'}>
                                                                {remoteArtist.artistType && <>
                                                                    <div className="col-span-1 text-xs text-gray-500"></div>
                                                                    <div className="col-span-2 text-xs text-gray-500">{remoteArtist.artistType} / {remoteArtist.majorType && remoteArtist.majorType}</div>
                                                                </>}
                                                                {remoteArtist.webpage && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">webpage:</div>
                                                                    <div className="col-span-2 text-xs text-gray-500">{remoteArtist.webpage}</div>
                                                                </>}
                                                                {remoteArtist.wikipedia && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">wikipedia:</div>
                                                                    <div className="col-span-2 text-xs text-gray-500">{remoteArtist.wikipedia}</div>
                                                                </>}
                                                                {remoteArtist.facebook && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">facebook:</div>
                                                                    <div className="col-span-2 truncate text-xs text-gray-500"> {remoteArtist.facebook}</div>
                                                                </>}
                                                                {remoteArtist.twitter && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">x:</div>
                                                                    <div className="col-span-2 truncate text-xs text-gray-500"> {remoteArtist.twitter}</div>
                                                                </>}
                                                                {remoteArtist.youtube && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">YouTube:</div>
                                                                    <div className="col-span-2 truncate text-xs text-gray-500"> {remoteArtist.youtube}</div>
                                                                </>}
                                                                {remoteArtist.itunes && <>
                                                                    <div className="col-span-1 truncate text-xs text-gray-500">Apple
                                                                        Music:
                                                                    </div>
                                                                    <div className="col-span-2 truncate text-xs text-gray-500"> {remoteArtist.itunes}</div>
                                                                </>}
                                                                {remoteArtist.spotify && <>
                                                                    <div className="col-span-1 text-xs text-gray-500">Spotify:</div>
                                                                    <div className="col-span-2 truncate text-xs text-gray-500"> {remoteArtist.spotify}</div>
                                                                </>}
                                                                {remoteArtist.musicbrainzID && <>
                                                                    <div className="text-xs text-gray-500">MusicbrainzID:</div>
                                                                    <div className="col-span-2 text-xs text-gray-500"> {remoteArtist.musicbrainzID}</div>
                                                                </>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>)}
                                            </div>
                                            <div className={'md:col-span-1'}>
                                                <div className="text-2xl text-gray-500">Sources</div>
                                                {sources && sources.map((source, index) => (<>
                                                    {source.source !== 'redirect' && source.source !== 'tmTap' && source.source !== 'ticketFly' &&
                                                     <div className="p-2" key={index}
                                                          onClick={() => getRemoteArtist(source.key, source.source)}>
                                                         <div className="text-sm font-medium text-gray-500">{source.source}</div>
                                                         <div className="text-xs text-gray-500">{source.key}</div>
                                                     </div>}
                                                </>))}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>

        </div>)
}
